import { GridRenderCellParams } from "@mui/x-data-grid";

export const outletLedgerMetadata = {
  columns: [
    {
      headerName: "Outlet Name & Code",
      headerParts: { top: "Outlet Name", bottom: "& Code" },
      mappedValue: "outletName, outletCode",
      width: 200,
      headerAlign: "left",
      align: "left",
      cellRenderElement: (params: GridRenderCellParams) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ overflow: "hidden", textOverflow: "ellipsis", width: "22rem", whiteSpace: "nowrap" }}>
            {params?.row?.outletName}
          </div>
          <div style={{ overflow: "hidden", textOverflow: "ellipsis", width: "22rem", whiteSpace: "nowrap" }}>
            <div>{params?.row?.outletCode}</div>
          </div>
        </div>
      )
      //   visibility: false,
    },
    {
      headerName: "Created On",
      mappedValue: "createdOn",
      width: 100,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Last Billed Date",
      mappedValue: "lastBilledDate",
      width: 100,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Last Payment Date",
      mappedValue: "lastPaymentDate",
      width: 100,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Balance Due",
      mappedValue: "creditAmount",
      width: 100,
      headerAlign: "left",
      align: "left",
    }
  ],
  Actions: ["redirect"],
};

export const outletLedgerDocumentMetaData = {
  columns: [
    {
      headerName: "Document Date", mappedValue: "documentDate", width: 200, headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Document ID", mappedValue: "documentId", width: 200, headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Description", mappedValue: "description", width: 200, headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Particular", mappedValue: "particular", width: 200, headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Debit", mappedValue: "debitAmount", width: 200, headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Credit", mappedValue: "creditAmount", width: 200, headerAlign: "left",
      align: "left",
    }
  ],
  Actions:[]
}

export const collectionMetaData1: any[]=[
                { label: "Outlet Name", keys: "outletName", index: 0 ,removeEllipsis: true,},
                { label: "Outlet Code", keys: "outletCode", index: 1 ,removeEllipsis: true,},
                { label: "Created On", keys: "createdOn", index: 2 , removeEllipsis: true,},
]
export const collectionMetaData2: any[]=[
                { label: "Last Billed Date", keys: "lastBilledDate", index: 0 ,removeEllipsis: true,},
                { label: "Last Payment Date", keys: "lastPaymentDate", index: 1 ,removeEllipsis: true,},
                { label: "Balance Due", keys: "creditAmount", index: 2 ,removeEllipsis: true,},
]